// Actions
export const GET_NEXT_AUTHORS = 'GET_NEXT_AUTHORS'
export const GET_AUTHOR_DATA_FROM_REFERENCE = 'GET_AUTHOR_DATA_FROM_REFERENCE'
export const UPDATE_AUTHORS_DATES = 'UPDATE_AUTHORS_DATES'
export const MERGE_AUTHOR = 'MERGE_AUTHOR'
export const RESET_AUTHORS_ACTION = 'RESET_AUTHORS_ACTION'

// Mutations
export const UPDATE_AUTHORS_PUBLISHED_AT = 'UPDATE_AUTHORS_PUBLISHED_AT'
export const REFRESH_AUTHORS_PUBLISHED_AT = 'REFRESH_AUTHORS_PUBLISHED_AT'
export const ADD_AUTHOR_REF = 'ADD_AUTHOR_REF'
export const SET_AUTHOR_DATA = 'SET_AUTHOR_DATA'
export const UPDATE_AUTHOR_REF = 'UPDATE_AUTHOR_REF'
export const MERGE_AUTHOR_DATA = 'MERGE_AUTHOR_DATA'
export const DELETE_AUTHOR = 'DELETE_AUTHOR'
export const RESET_AUTHORS = 'RESET_AUTHORS'
export const MERGE_AUTHOR_POST_DATA = 'MERGE_AUTHOR_POST_DATA'



// WEBPACK FOOTER //
// ./src/store/actions/authorQueries.js